import { ensureIsArray } from './utils.js'


class ShapeFillInterleaveArgs {
    // curveCount - The number of initial outer curves to create and work
    //              with using the subsequent arguments. 
    // maxLayers - how many rings to add on.  
    // thickness - [min, max] - thickness as a percent of the 
    //             parent (will use the radius, be a percent of that)
    //             If the same, will be consistent, otherwise randomized.
    // coverage - How much of the shape the curves should cover 
    //            at the first layer.  
    //
    //
    //// Change or adjustment parameters
    // change - How quickly to shink or grow those rings.  
    //          A percent change. Replaces attenuate since it can grow 
    //          or shrink.  
    // rotation - Optional argument to shift the layers moving outward. 
    //            Unlike change does not alter the size, it adjusts position
    //            rotationally. Positive is counterclock, negative clockwise. 
    // spacing - [min, max], Add spacing between layers, uses same 
    //           calculations as thickness. If values are the same 
    //           spacing will be consistent.
    // thicknessRandSize - [min, max] - 
    // alternates - Configure the ability to create a sequence of shape 
    //              sizes in a layer. the values must add to one 
    //              (or else will be normalized to 1) and then are used 
    //              to add layers sized based on those ratios 
    //              for the layer. 
    //              Exact calculations are TBD so will see how it works.  
    //
    constructor(
        curveCount,
        maxLayers,
        thickness,
        coverage,
        centerPt
    ) {
        this.curveCount = curveCount
        this.maxLayers = maxLayers
        thickness = ensureIsArray(thickness)
        this.thickness = thickness.length < 2 ? Array(2).fill(thickness[0]) : thickness
        this.coverage = coverage
        this.centerPt = centerPt
        this.startParam = 0
        
        this.innerPct = 0
        // This controls the size difference of the 
        // alternating pieces so that there is more contrast control
        // NOT YET IMPLEMENTED
        this.alternateDiff = 0
        this.change = 0
        this.changeCompound = true
        this.rotation = 0
        this.spacing = [0, 0]
        this.subSizes = [1]
    }

    setChange(change) {
        this.change = change
        return this
    }

    setChangeCompound(compound) {
        this.changeCompound = compound
        return this
    }

    setSpacing(spacing) {
        spacing = ensureIsArray(spacing)
        this.spacing = spacing.length < 2 ? Array(2).fill(spacing[0]) : spacing
        return this
    }

    setRotation(rotation) {
        this.rotation = rotation
        return this
    }

    setSubSize(subSizes) {
        this.subSizes = subSizes
        return this
    }

    setInnerPct(pct) {
        this.innerPct = pct
        return this
    }

    setAlternateDiff(diff) {
        this.alternateDiff = diff
        return this
    }
}

export { ShapeFillInterleaveArgs }
